<template>
  <LayoutCNMenuDesktopContainer>
    <template #left>
      <KeepAlive>
        <li
          v-for="(item, index) in formatSolutionsMenu"
          :key="hash(item)"
          class="mb-4 last:mb-0"
        >
          <div>
            <MenuLink v-if="validIsNuxtLink(item)" :data="item" />
            <p
              v-if="!validIsNuxtLink(item)"
              class="mb-1 px-2 py-1 text-sm font-bold text-gray-600"
            >
              {{ item.name }}
            </p>
          </div>
          <ul v-if="item.subMenus.length">
            <li
              v-for="(subItem, subIndex) in item.subMenus"
              :key="hash(subItem)"
              class="mb-0.5 last:mb-0"
            >
              <MenuLink
                :data="subItem"
                :current="
                  current.index === index && current.subIndex === subIndex
                "
                @click="handleClick(subItem, index, subIndex)"
              />
            </li>
          </ul>
        </li>
      </KeepAlive>
    </template>
    <template #right>
      <LayoutCNMenuDesktopContent
        v-if="currentData"
        :type="menuName.CN_SOLUTIONS"
        :link="currentData?.link"
      >
        <KeepAlive>
          <div v-for="(item, index) in formatSolutionsMenu" :key="hash(item)">
            <LayoutCNMenuDesktopCategory
              v-for="(subItem, subIndex) in item.subMenus"
              v-show="current.index === index && current.subIndex === subIndex"
              :key="hash(subItem)"
              :list="subItem.subMenus"
            />
          </div>
        </KeepAlive>
      </LayoutCNMenuDesktopContent>
    </template>
  </LayoutCNMenuDesktopContainer>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import MenuLink from '@/components/Layout/CNMenu/Desktop/MenuLink.vue';
  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatMenu } from '@/stores/menuStore';

  const menuStore = useMenuStore();
  const { menuName, formatSolutionsMenu } = storeToRefs(menuStore);

  const current = ref<{ index: number; subIndex: number }>({
    index: 0,
    subIndex: 0,
  });

  const currentData = computed((): IFormatMenu | null => {
    const { index, subIndex } = current.value;
    return formatSolutionsMenu.value[index]?.subMenus[subIndex] || null;
  });

  const handleClick = (
    payload: IFormatMenu,
    index: number,
    subIndex: number
  ): void => {
    if (!validIsNuxtLink(payload)) {
      current.value.index = index;
      current.value.subIndex = subIndex;
    }

    window.gtag('event', 'site_click', {
      Item: 'Navigation',
      Item_Cate: menuName.value.CN_SOLUTIONS,
      Item_Name: payload.name,
    });
  };
</script>
